export const ONE_OFF_SITES = [
  { slug: 'uvalde-garner-field', label: 'Garner Field block' },
  { slug: 'meiners-ranch-la-salle', label: 'Meiners Ranch' },
  { slug: 'cooper-draw', label: 'Cooper Draw' },
] as const;

export function isOneOffZone(slug: string): boolean {
  return ONE_OFF_SITES.some(site => site.slug === slug);
}
